import { render, staticRenderFns } from "./schemeDetail.vue?vue&type=template&id=6c570f74&scoped=true&"
import script from "./schemeDetail.vue?vue&type=script&lang=js&"
export * from "./schemeDetail.vue?vue&type=script&lang=js&"
import style0 from "./schemeDetail.vue?vue&type=style&index=0&id=6c570f74&scoped=true&lang=css&"
import style1 from "./schemeDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c570f74",
  null
  
)

export default component.exports